import type { TableFieldSchema } from '@carboncopyco/editor-utils';
import type { Table } from '@tanstack/react-table';
import { FieldPanel, type FieldPanelProps } from '../FieldPanel';
import { ColumnsFilter } from './ColumnsFilter';
import { ExportToSpreadsheet } from './ExportToSpreadsheet';

export type TableFieldPanelProps = FieldPanelProps<TableFieldSchema> & {
  getTableInstance: () => Table<Record<string, unknown>>;
  onUpdateTable: (newdData: Record<string, unknown>[]) => void;
};

export const TableFieldPanel = ({
  editable,
  onChange,
  getTableInstance,
  onUpdateTable,
  onRemoveField,
  field,
  children,
}: TableFieldPanelProps) => {
  const table = getTableInstance();
  return (
    <FieldPanel.EditableFieldPanel editable={editable}>
      <span className="flex flex-1 max-w-full gap-1.5 items-center">
        <ColumnsFilter columns={table.getAllLeafColumns()} />
        <FieldPanel.Label
          label={field.uiSchema.label}
          htmlFor={field.jsonPath}
          editable={editable}
          onChange={(label) =>
            onChange?.({
              ...field,
              uiSchema: {
                ...field.uiSchema,
                label,
              },
            })
          }
        />
        {!editable && (
          <div className="flex gap-1.5">
            <span className="border-l border-ds-natural-150" />
            <ExportToSpreadsheet
              table={table}
              onUpdateTable={onUpdateTable}
            />
          </div>
        )}
        {editable && (
          <FieldPanel.RemoveIcon
            onClick={() => onRemoveField?.(field.jsonPath)}
          />
        )}
      </span>
      {children}
    </FieldPanel.EditableFieldPanel>
  );
};
